import React from 'react'
import './BMI.css'
import ht from './../../Photo/healty.png'
import {useLocation} from 'react-router-dom';
import { useNavigate } from "react-router-dom";

const Healthy = () => {

    const location = useLocation();
    const navigate=useNavigate();

    const nav=()=>{
      navigate("/bmi")
    }
    
  return (
    
     <div className='appp'>
        <div className='containerr'>
         <img  className='imgg' src={ht} alt="img not found" />
          <h3>You are healthy</h3>
          <h3>Your BMI is {(location.state.bmi).toFixed(2)}</h3>
          <button className='butn'  onClick={nav} >Go Back</button>         
        </div>
    </div>
  )
}

export default Healthy;